// extracted by mini-css-extract-plugin
export default {"billboard":"Billboard_billboard__9RRCV","content":"Billboard_content__bOncU"};